(() => {
  const instances = new Map();
  function mount(root) {
    if (!root || instances.has(root)) return;
    const controller = new AbortController(), signal = controller.signal;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 701px)');
    const records = [...root.querySelectorAll('.cafe-category')].map(details => ({details, summary: details.querySelector('summary'), content: details.querySelector('.cafe-category-content'), expanded: false, animation: null}));
    let alignment = 0;
    const stopAlign = () => {cancelAnimationFrame(alignment);alignment = 0;};
    const setExpanded = (record, expanded, immediate = false) => {
      const {details, summary, content} = record;
      const from = details.getBoundingClientRect().height;
      record.animation?.cancel();record.animation = null;
      record.expanded = expanded;content.inert = !expanded;
      summary.setAttribute('aria-expanded', String(expanded));
      if (immediate || reduced.matches) {details.open = expanded;details.style.overflow = '';return;}
      details.open = true;
      const to = summary.getBoundingClientRect().height + (expanded ? content.getBoundingClientRect().height : 0) + 2;
      details.style.overflow = 'hidden';
      const animation = details.animate([{height: `${from}px`}, {height: `${to}px`}], {duration: 460, easing: 'cubic-bezier(.22,.8,.25,1)'});
      record.animation = animation;
      animation.onfinish = () => {if (record.animation !== animation) return;details.open = expanded;details.style.overflow = '';record.animation = null;};
    };
    const align = record => {
      stopAlign();
      const start = scrollY, began = performance.now();
      const tick = now => {
        const header = document.querySelector('[data-pad-navigation]');
        const top = Math.max(0, record.summary.getBoundingClientRect().top + scrollY - (header?.getBoundingClientRect().height || 88) - 16);
        const progress = reduced.matches ? 1 : Math.min(1, (now - began) / 500);
        scrollTo({top: start + (top - start) * (1 - Math.pow(1 - progress, 3)), behavior: 'instant'});
        if (progress < 1) alignment = requestAnimationFrame(tick);else alignment = 0;
      };
      alignment = requestAnimationFrame(tick);
    };
    records.forEach(record => {
      const drinks = [...record.content.querySelectorAll('[data-cafe-drink]')];
      const scenes = [...record.content.querySelectorAll('[data-cafe-scene]')];
      const select = button => {
        drinks.forEach(drink => drink.setAttribute('aria-pressed', String(drink === button)));
        scenes.forEach(scene => {scene.hidden = scene.dataset.cafeScene !== button.dataset.cafeDrink;});
      };
      setExpanded(record, false, true);
      record.summary.addEventListener('click', event => {
        event.preventDefault();
        const expand = !record.expanded;
        if (expand) records.forEach(other => {if (other !== record && other.expanded) setExpanded(other, false);});
        setExpanded(record, expand);
        if (expand) align(record);else stopAlign();
      }, {signal});
      drinks.forEach(button => {
        button.addEventListener('pointerenter', () => {if (desktop.matches) select(button);}, {signal});
        button.addEventListener('focus', () => select(button), {signal});
        button.addEventListener('click', () => {
          select(button);
          if (desktop.matches) scenes.find(scene => scene.dataset.cafeScene === button.dataset.cafeDrink)?.querySelector('[data-pad-open-product]')?.click();
        }, {signal});
      });
    });
    ['wheel', 'touchstart', 'pointerdown'].forEach(type => window.addEventListener(type, stopAlign, {passive: true, signal}));
    window.addEventListener('keydown', stopAlign, {signal});
    const settle = () => {stopAlign();records.forEach(record => setExpanded(record, record.expanded, true));};
    window.addEventListener('resize', settle, {signal});
    reduced.addEventListener('change', settle, {signal});
    instances.set(root, () => {stopAlign();controller.abort();records.forEach(record => record.animation?.cancel());});
  }
  document.querySelectorAll('.cafe-selection').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.cafe-selection').forEach(mount));
  document.addEventListener('shopify:section:unload', event => {for (const [root, dispose] of instances) {if (event.target.contains(root)) {dispose();instances.delete(root);}}});
})();
